export default __webpack_public_path__ + "static/media/benefit_1@3x.aa4e4209.png";